function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M277.979 197.243L176.992 252.039L131.63 226.226L119.63 219.282L83.7027 198.451L184.766 143.503L277.979 197.243Z",
  fill: "#91D6E6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M83.5514 204.108L176.916 257.696V251.96L83.5514 198.372V204.108Z",
  fill: "#6AB3E3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M277.979 202.9L176.991 257.772V252.186L278.054 197.24L277.979 202.9Z",
  fill: "#4D8EB2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M93.3635 198.449L176.917 246.377V240.64L93.3635 192.713V198.449Z",
  fill: "#6AB3E3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M268.243 197.091L177.067 246.377V240.792L268.318 191.431L268.243 197.091Z",
  fill: "#4D8EB2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 221.448V225.221L230.397 194.579V190.804L177.865 221.448Z",
  fill: "#5F3D77"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 221.45V225.224L125.182 194.505V190.731L177.865 221.45Z",
  fill: "#9E76B4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M125.182 190.807L177.865 221.45L230.321 190.807L177.563 160.088L125.182 190.807Z",
  fill: "#D3BFDD"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 195.029V219.181L226.623 190.727V166.574L177.865 195.029Z",
  fill: "#5F3D77"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 202.278V219.185L226.623 190.73V173.823L177.865 202.278Z",
  fill: "#D3BFDD"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 195.032V219.185L128.956 190.655V166.502L177.865 195.032Z",
  fill: "#5F3D77"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 202.276V219.182L128.956 190.652V173.746L177.865 202.276Z",
  fill: "#8C63AA"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M196.282 177.141L191.527 180.084V211.407L196.282 208.463V177.141ZM204.962 172.159L200.206 175.103V206.35L204.962 203.406V172.159ZM213.717 167.102L208.961 170.046V201.369L213.717 198.425V167.102ZM222.397 162.121L217.641 165.065V196.387L222.397 193.444V162.121ZM182.772 185.141V216.464L187.527 213.521V182.198L182.772 185.141Z",
  fill: "#5F3D77"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M159.072 208.466L163.827 211.41V180.087L159.072 177.143V208.466ZM150.392 203.485L155.147 206.428V175.106L150.392 172.162V203.485ZM141.637 198.428L146.392 201.371V170.049L141.637 167.105V198.428ZM132.957 193.371L137.712 196.314V164.991L132.957 162.048V193.371ZM167.827 182.2V213.523L172.582 216.467V185.144L167.827 182.2Z",
  fill: "#D3BFDD"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 185.219V198.352L230.397 167.708V154.575L177.865 185.219Z",
  fill: "#8C63AA"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 185.223V198.356L125.182 167.636V154.503L177.865 185.223Z",
  fill: "#9E76B4"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M125.182 154.499L177.865 185.142L230.321 154.499L177.563 123.78L125.182 154.499Z",
  fill: "#D3BFDD"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 174.352V182.956L226.623 154.502V145.897L177.865 174.352Z",
  fill: "#5F3D77"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 181.595V182.954L226.623 154.5V153.141L177.865 181.595Z",
  fill: "#2E2B2B"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 174.352V182.956L128.956 154.427V145.897L177.865 174.352Z",
  fill: "#8C63AA"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 181.597V182.957L128.956 154.427V153.067L177.865 181.597Z",
  fill: "#4D4849"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 164.54V177.673L230.397 147.03V133.897L177.865 164.54Z",
  fill: "#8C63AA"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 164.538V177.67L125.182 146.952V133.818L177.865 164.538Z",
  fill: "#9E76B4"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M125.182 133.821L177.865 164.465L230.321 133.821L177.563 103.103L125.182 133.821Z",
  fill: "#D3BFDD"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 153.669V162.273L226.623 133.818V125.214L177.865 153.669Z",
  fill: "#5F3D77"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 160.918V162.276L226.623 133.821V132.463L177.865 160.918Z",
  fill: "#2E2B2B"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 153.669V162.273L128.956 133.743V125.214L177.865 153.669Z",
  fill: "#8C63AA"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 160.915V162.273L128.956 133.743V132.385L177.865 160.915Z",
  fill: "#4D4849"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 143.785V156.917L230.397 126.274V113.141L177.865 143.785Z",
  fill: "#8C63AA"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 143.782V156.915L125.182 126.196V113.063L177.865 143.782Z",
  fill: "#9E76B4"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M125.182 113.138L177.865 143.781L230.321 113.138L177.563 82.4189L125.182 113.138Z",
  fill: "#D3BFDD"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 133.215V141.819L226.623 113.365V104.76L177.865 133.215Z",
  fill: "#5F3D77"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 140.463V141.821L226.623 113.367V112.009L177.865 140.463Z",
  fill: "#2E2B2B"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 133.215V141.819L128.956 113.289V104.76L177.865 133.215Z",
  fill: "#8C63AA"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 140.462V141.82L128.956 113.29V111.932L177.865 140.462Z",
  fill: "#4D4849"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 123.404V136.537L230.397 105.893V92.7603L177.865 123.404Z",
  fill: "#8C63AA"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 123.401V136.534L125.182 105.816V92.6821L177.865 123.401Z",
  fill: "#9E76B4"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M125.182 92.6849L177.865 123.328L230.321 92.6849L177.563 61.9663L125.182 92.6849Z",
  fill: "#D3BFDD"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 112.537V121.142L226.623 92.6871V84.083L177.865 112.537Z",
  fill: "#5F3D77"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 119.781V121.14L226.623 92.6846V91.3262L177.865 119.781Z",
  fill: "#2E2B2B"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 112.537V121.142L128.956 92.6121V84.083L177.865 112.537Z",
  fill: "#8C63AA"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 119.782V121.14L128.956 92.6104V91.252L177.865 119.782Z",
  fill: "#4D4849"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 102.721V115.853L230.397 85.21V72.0771L177.865 102.721Z",
  fill: "#8C63AA"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 102.723V115.856L125.182 85.1377V72.0049L177.865 102.723Z",
  fill: "#9E76B4"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M125.182 72.0069L177.865 102.65L230.321 72.0069L177.563 41.2876L125.182 72.0069Z",
  fill: "#D3BFDD"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 91.8543V100.458L226.623 72.0043V63.3994L177.865 91.8543Z",
  fill: "#5F3D77"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 99.0982V100.457L226.623 72.0025V70.644L177.865 99.0982Z",
  fill: "#2E2B2B"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 91.8541V100.458L128.956 71.9282V63.3999L177.865 91.8541Z",
  fill: "#8C63AA"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 99.1003V100.459L128.956 71.9288V70.5703L177.865 99.1003Z",
  fill: "#4D4849"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 82.0439V95.1767L230.397 64.5332V51.4004L177.865 82.0439Z",
  fill: "#8C63AA"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 82.0406V95.1734L125.182 64.4548V51.3213L177.865 82.0406Z",
  fill: "#9E76B4"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M125.182 51.4029L177.865 82.0464L230.321 51.4029L177.563 20.6836L125.182 51.4029Z",
  fill: "#D3BFDD"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 71.2501V79.8542L226.623 51.4V42.7959L177.865 71.2501Z",
  fill: "#5F3D77"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 78.4208V79.7792L226.623 51.3243V49.9658L177.865 78.4208Z",
  fill: "#2E2B2B"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 71.2501V79.8542L128.956 51.3242V42.7959L177.865 71.2501Z",
  fill: "#8C63AA"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 78.4172V79.7757L128.956 51.2457V49.8872L177.865 78.4172Z",
  fill: "#4D4849"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 61.3598V74.4926L230.397 43.8491V30.7163L177.865 61.3598Z",
  fill: "#8C63AA"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M177.865 61.3626V74.4954L125.182 43.7769V30.644L177.865 61.3626Z",
  fill: "#9E76B4"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M125.182 30.7186L177.865 61.362L230.321 30.7186L177.563 0L125.182 30.7186Z",
  fill: "#D3BFDD"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M166.015 41.3608L177.488 48.0781L189.111 41.3608L177.639 34.6436L166.015 41.3608Z",
  fill: "url(#paint0_linear_259_1144)"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M160.883 51.1697L141.108 39.7729C131.674 34.3383 132.805 24.7532 143.75 18.4127L157.864 10.2612C168.808 3.9207 185.337 3.2422 194.772 8.75186L214.547 20.1487C223.982 25.5833 222.85 35.1684 211.905 41.5081L197.791 49.6597C186.923 56.0001 170.393 56.6786 160.883 51.169V51.1697Z",
  fill: "#D3BFDD"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M209.489 26.6422V20.1509H146.24V27.3215C145.863 30.1893 147.372 32.982 150.844 34.9446L165.336 43.3228C172.279 47.3231 184.431 46.7948 192.431 42.1903L202.771 36.2273C207.678 33.5104 209.866 29.9626 209.489 26.6422H209.489Z",
  fill: "#8C63AA"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M209.489 21.5103V20.1519H146.24V22.2654C145.863 25.1331 147.372 27.9259 150.844 29.8885L165.336 38.266C172.279 42.2663 184.431 41.7379 192.431 37.1334L202.771 31.1705C207.678 28.4535 209.866 24.83 209.489 21.5096L209.489 21.5103Z",
  fill: "#4D4849"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M165.412 35.2466L150.92 26.8691C143.976 22.8688 144.882 15.8498 152.883 11.2453L163.223 5.28232C171.224 0.678544 183.375 0.149441 190.319 4.14978L204.81 12.5272C211.754 16.5276 210.848 23.5466 202.847 28.1511L192.507 34.114C184.507 38.7936 172.355 39.322 165.412 35.2458V35.2466Z",
  fill: "#D3BFDD"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M192.055 18.5655V8.98047H163.6V18.943C163.449 20.2264 164.128 21.5091 165.713 22.415L172.205 26.1887C175.299 27.9997 180.809 27.7738 184.356 25.6603L189.036 22.9434C191.3 21.66 192.281 20.0749 192.055 18.5655Z",
  fill: "#8C63AA"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M192.055 11.9241V8.98047H163.6V12.3016C163.449 13.585 164.128 14.8676 165.713 15.7735L172.205 19.5472C175.299 21.3583 180.809 21.1323 184.431 19.0188L189.111 16.3012C191.3 15.0936 192.281 13.4334 192.055 11.9233V11.9241Z",
  fill: "#4D4849"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M172.28 15.7735L165.789 11.9998C162.695 10.1888 163.072 7.01856 166.695 4.98086L171.375 2.26392C174.997 0.150427 180.432 -0.0762272 183.601 1.73555L190.093 5.50923C193.187 7.32028 192.81 10.4905 189.187 12.5282L184.507 15.2452C180.885 17.3586 175.375 17.5853 172.28 15.7735H172.28Z",
  fill: "#D3BFDD"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M133.431 69.4529V135.366L165.716 154.057V88.1442C165.627 76.3393 158.383 62.6555 149.529 57.5576C147.383 56.3055 145.415 55.6795 143.537 55.5898C143.358 55.5898 143.269 55.5898 143.09 55.5898C137.545 55.5898 133.52 60.7767 133.431 69.4522V69.4529Z",
  fill: "#D1CC92"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M139.959 66.8591V132.772L165.716 147.707V88.1442C165.626 76.3393 158.382 62.6555 149.528 57.5576C147.382 56.3055 145.414 55.6795 143.536 55.5898C141.39 57.9147 140.048 61.7605 139.958 66.8584L139.959 66.8591Z",
  fill: "#EFE4AC"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M133.239 71.9098L165.955 89.8855C165.977 89.8971 165.995 89.9307 165.995 89.9584L165.826 155.163C165.826 155.251 136.907 137.94 133.239 135.925C133.217 135.913 133.2 135.879 133.2 135.852V71.939C133.2 71.9113 133.217 71.8975 133.239 71.9098Z",
  fill: "#F58220"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M121.983 76.0722V79.2023L122.609 79.918C123.146 80.544 123.683 81.0804 124.219 81.7065C124.755 82.2429 125.293 82.78 125.919 83.3164C127.081 84.3002 128.243 85.2841 129.407 86.1783C130.659 87.0726 131.821 87.8779 133.163 88.6825C134.415 89.4878 135.757 90.2027 137.009 90.9184C139.602 92.349 142.285 93.6011 145.057 94.7635C146.399 95.2999 147.83 95.837 149.261 96.2838C150.692 96.7312 152.123 97.178 153.733 97.4462L154.18 97.5351L154.27 97.4462L164.913 91.3644L165.896 90.828V87.6979L155.433 84.9255L154.717 84.5677L133.79 72.8516L133.521 72.6724L133.253 72.8516L125.741 77.1442L121.985 76.0715L121.983 76.0722Z",
  fill: "#F15B38"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M154.269 84.5686V97.3575L164.911 91.2764L165.895 90.7393V87.6092L155.432 84.8368L154.716 84.479L154.269 84.5686Z",
  fill: "#BE1E2D"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M133.43 69.632V69.3638C133.519 57.6477 140.764 52.2817 149.618 57.3795C158.472 62.4774 165.716 76.1605 165.805 87.9662V89.4865L133.43 70.7951V69.6327L133.43 69.632Z",
  fill: "#F58220"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M122.519 75.8072L133.162 69.7262L133.43 69.5469L133.698 69.7262L164.821 87.1654L165.805 87.7018L164.821 88.2382L154.089 94.4089L153.641 94.32C152.121 94.0518 150.691 93.6043 149.17 93.1575C147.739 92.7101 146.308 92.1737 144.966 91.6373C142.194 90.5645 139.51 89.2228 136.917 87.8811C135.575 87.1654 134.323 86.4505 133.071 85.6451C131.819 84.8398 130.567 84.0353 129.315 83.141C128.153 82.2468 126.901 81.3526 125.827 80.2791C125.291 79.7427 124.665 79.2063 124.128 78.6692C123.591 78.1328 123.055 77.5067 122.518 76.8807L121.892 76.165L122.518 75.8072H122.519Z",
  fill: "#EE312D"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M150.347 123.372V126.748C150.347 127.383 149.829 127.627 149.194 127.292C148.56 126.958 148.04 126.164 148.04 125.529V122.153C147.168 121.267 146.568 120.052 146.568 119.015C146.568 117.566 147.744 117.011 149.194 117.778C150.645 118.545 151.821 120.343 151.821 121.793C151.821 122.829 151.22 123.408 150.347 123.373L150.347 123.372ZM157.712 118.087L140.676 109.08C139.795 108.615 139.074 108.891 139.074 109.694V125.22C139.074 126.024 139.796 127.064 140.676 127.53L157.712 136.537C158.594 137.003 159.316 136.727 159.316 135.923V120.396C159.316 119.593 158.594 118.554 157.712 118.088V118.087Z",
  fill: "white"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M144.08 109.571V104.822C144.08 102.055 146.332 100.994 149.099 102.457C151.866 103.919 154.117 107.361 154.117 110.129V114.877L157.305 116.562V111.814C157.305 107.289 153.624 101.662 149.099 99.2689C144.574 96.8763 140.893 98.6123 140.893 103.137V107.885L144.08 109.57L144.08 109.571Z",
  fill: "white"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M299.362 183.94C292.452 187.955 282.088 188.328 276.112 184.873C270.136 181.419 270.883 175.443 277.792 171.428C284.702 167.413 295.066 167.039 301.042 170.494C307.018 173.949 306.271 179.925 299.361 183.94H299.362Z",
  fill: "#79903A"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M305.244 86.2726C305.244 92.0614 300.482 96.8233 294.693 96.8233C288.905 96.8233 284.143 92.0614 284.143 86.2726C284.143 80.4831 288.905 75.7212 294.693 75.7212C300.575 75.7212 305.244 80.3898 305.244 86.2726Z",
  fill: "#7FA25A"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M295.813 98.7853C295.813 98.7853 294.693 89.8218 297.214 84.3129L296.374 83.6592C296.374 83.6592 293.199 92.9032 293.199 99.0658C295.254 99.8128 295.254 98.692 295.254 98.692L295.814 98.7853H295.813Z",
  fill: "#764443"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M295.16 90.0079C295.16 90.0079 293.293 85.3392 290.211 83.8452C290.211 83.8452 293.853 88.14 294.133 93.0892C295.16 91.222 295.16 90.0079 295.16 90.0079Z",
  fill: "#995C5A"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M295.533 98.694C295.533 99.1605 294.973 99.5343 294.88 100.001C294.786 100.469 295.253 101.028 295.16 101.402C295.066 101.869 294.319 102.056 294.133 102.429C293.946 102.802 294.133 103.456 293.946 103.83C293.666 104.204 293.013 104.204 292.639 104.484C292.359 104.763 292.359 105.51 291.985 105.791C291.612 106.071 290.958 105.791 290.584 105.978C290.21 106.164 290.024 106.818 289.557 107.004C289.184 107.098 288.624 106.725 288.157 106.725C287.689 106.818 287.316 107.378 286.849 107.378C286.383 107.378 286.009 106.818 285.542 106.725C285.075 106.631 284.515 107.098 284.141 107.004C283.674 106.911 283.487 106.164 283.114 105.978C282.74 105.791 282.087 105.978 281.713 105.791C281.34 105.511 281.34 104.857 281.06 104.484C280.78 104.204 280.033 104.204 279.752 103.83C279.472 103.456 279.752 102.803 279.566 102.429C279.379 102.055 278.725 101.869 278.539 101.402C278.445 101.028 278.819 100.469 278.819 100.001C278.725 99.5351 278.165 99.1612 278.165 98.694C278.165 98.2276 278.725 97.8537 278.819 97.3866C278.912 96.9194 278.445 96.3597 278.539 95.9859C278.632 95.5194 279.379 95.3321 279.566 94.959C279.752 94.5851 279.566 93.9321 279.752 93.5582C280.032 93.1851 280.686 93.1851 281.06 92.9045C281.34 92.6247 281.34 91.8777 281.713 91.5971C282.087 91.3172 282.74 91.5971 283.114 91.4105C283.487 91.2239 283.675 90.5702 284.141 90.3836C284.514 90.2904 285.075 90.6635 285.542 90.6635C286.008 90.5702 286.382 90.0098 286.849 90.0098C287.316 90.0098 287.689 90.5702 288.157 90.6635C288.623 90.7568 289.184 90.2896 289.557 90.3836C290.024 90.4769 290.211 91.2239 290.584 91.4105C290.957 91.5971 291.611 91.4105 291.985 91.5971C292.359 91.8769 292.359 92.5307 292.639 92.9045C292.919 93.1844 293.666 93.1844 293.946 93.5582C294.226 93.9321 293.946 94.5851 294.133 94.959C294.319 95.3321 294.973 95.5194 295.16 95.9859C295.253 96.3597 294.88 96.9194 294.88 97.3866C294.973 97.853 295.533 98.2269 295.533 98.694Z",
  fill: "#9DCA68"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M312.901 102.056C312.901 102.616 312.154 103.176 312.06 103.736C311.967 104.297 312.527 105.044 312.34 105.603C312.154 106.164 311.219 106.444 311.033 106.911C310.753 107.471 311.126 108.312 310.753 108.778C310.38 109.244 309.445 109.244 309.072 109.618C308.698 109.991 308.698 110.926 308.232 111.299C307.766 111.672 306.925 111.299 306.365 111.579C305.898 111.859 305.618 112.7 305.057 112.886C304.497 113.073 303.75 112.512 303.19 112.606C302.63 112.7 302.07 113.447 301.51 113.447C300.949 113.447 300.389 112.7 299.829 112.606C299.269 112.513 298.522 113.073 297.962 112.886C297.401 112.7 297.122 111.765 296.654 111.579C296.094 111.299 295.254 111.672 294.787 111.299C294.321 110.925 294.321 109.991 293.947 109.618C293.574 109.244 292.639 109.244 292.266 108.778C291.893 108.311 292.266 107.47 291.986 106.911C291.707 106.444 290.866 106.164 290.679 105.603C290.492 105.043 291.052 104.296 290.959 103.736C290.866 103.176 290.119 102.615 290.119 102.056C290.119 101.495 290.866 100.935 290.959 100.375C291.052 99.8145 290.492 99.0675 290.679 98.5078C290.866 97.9474 291.799 97.6675 291.986 97.2003C292.266 96.7339 291.893 95.7996 292.266 95.3332C292.64 94.8668 293.574 94.8668 293.947 94.4929C294.321 94.1198 294.321 93.1854 294.787 92.8123C295.254 92.4392 296.095 92.8123 296.654 92.5324C297.121 92.2526 297.401 91.4116 297.962 91.225C298.522 91.0384 299.269 91.5989 299.829 91.5048C300.389 91.4116 300.95 90.6646 301.51 90.6646C302.07 90.6646 302.63 91.4116 303.19 91.5048C303.751 91.5981 304.498 91.0384 305.057 91.225C305.618 91.4116 305.898 92.3459 306.365 92.5324C306.925 92.8123 307.766 92.4392 308.232 92.8123C308.698 93.1862 308.698 94.1198 309.072 94.4929C309.446 94.8668 310.38 94.8668 310.753 95.3332C311.127 95.8003 310.753 96.6406 311.033 97.2003C311.313 97.6668 312.154 97.9474 312.34 98.5078C312.527 99.0682 311.966 99.8153 312.06 100.375C312.154 100.935 312.901 101.402 312.901 102.056Z",
  fill: "#9DCA68"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M278.727 109.991C278.727 115.22 274.525 119.422 269.296 119.422C264.067 119.422 259.866 115.22 259.866 109.991C259.866 104.762 264.067 100.561 269.296 100.561C274.525 100.561 278.727 104.762 278.727 109.991Z",
  fill: "#7FA25A"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M327 112.512C327 112.979 326.346 113.446 326.253 113.913C326.16 114.379 326.627 115.034 326.533 115.5C326.346 115.967 325.599 116.154 325.412 116.621C325.225 117.088 325.505 117.835 325.132 118.208C324.852 118.582 324.011 118.582 323.731 118.955C323.357 119.329 323.451 120.076 322.984 120.356C322.611 120.636 321.864 120.356 321.397 120.636C320.931 120.823 320.743 121.663 320.277 121.757C319.81 121.943 319.156 121.383 318.69 121.477C318.223 121.57 317.756 122.224 317.289 122.224C316.822 122.224 316.355 121.57 315.888 121.477C315.421 121.384 314.767 121.851 314.301 121.757C313.834 121.57 313.647 120.823 313.181 120.636C312.713 120.449 311.966 120.729 311.593 120.356C311.219 120.076 311.219 119.235 310.846 118.955C310.473 118.582 309.726 118.676 309.446 118.208C309.166 117.835 309.446 117.088 309.166 116.621C308.979 116.154 308.139 115.967 308.046 115.5C307.859 115.034 308.419 114.38 308.325 113.913C308.232 113.446 307.578 112.979 307.578 112.512C307.578 112.045 308.232 111.579 308.325 111.111C308.419 110.645 307.952 109.991 308.046 109.524C308.232 109.058 308.979 108.87 309.166 108.404C309.352 107.937 309.072 107.19 309.446 106.817C309.725 106.444 310.566 106.444 310.846 106.07C311.22 105.696 311.126 104.95 311.593 104.669C311.966 104.389 312.713 104.669 313.181 104.389C313.647 104.202 313.834 103.362 314.301 103.269C314.768 103.082 315.422 103.642 315.888 103.549C316.355 103.455 316.822 102.802 317.289 102.802C317.755 102.802 318.222 103.455 318.69 103.549C319.157 103.642 319.81 103.176 320.277 103.269C320.743 103.455 320.931 104.202 321.397 104.389C321.863 104.576 322.611 104.296 322.984 104.669C323.358 104.949 323.358 105.789 323.731 106.07C324.104 106.444 324.852 106.35 325.132 106.817C325.412 107.191 325.132 107.938 325.412 108.404C325.599 108.87 326.439 109.058 326.533 109.524C326.719 109.991 326.159 110.645 326.253 111.111C326.346 111.579 327 112.045 327 112.512Z",
  fill: "#7FA25A"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M299.455 131.09C299.455 131.09 304.497 120.259 312.434 117.365C318.41 114.844 319.81 112.042 320.184 109.428C319.998 108.774 319.624 109.335 319.624 109.335C319.624 109.335 317.943 114.471 312.808 116.058C307.672 117.552 302.35 120.073 300.856 123.995C299.362 127.823 299.455 131.091 299.455 131.091V131.09Z",
  fill: "#995C5A"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M299.081 127.823C299.081 127.823 297.961 117.739 293.105 113.911C288.343 110.083 285.075 106.442 285.169 102.427C285.262 98.2253 285.822 97.0111 285.822 97.0111C285.822 97.0111 286.476 96.1708 286.57 96.9178C286.663 97.6648 284.422 102.987 287.69 106.628C290.958 110.27 299.642 114.565 300.202 124.556C300.016 127.544 299.082 127.824 299.082 127.824L299.081 127.823Z",
  fill: "#764443"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M288.998 153.875C288.998 153.875 287.69 146.779 285.076 143.044C282.462 139.216 281.622 136.508 281.622 136.508L280.128 137.909C280.128 137.909 282.742 143.605 284.049 145.472C285.357 147.34 287.597 155.09 287.41 158.825C289.838 156.77 288.998 153.875 288.998 153.875Z",
  fill: "#764443"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M290.678 165.828C290.678 165.828 290.305 153.597 292.079 148.554C293.853 143.511 302.163 128.479 302.163 121.009C302.163 113.54 298.989 109.898 299.269 107.003C299.549 104.109 302.257 101.027 302.257 101.027C302.257 101.027 298.336 103.175 298.429 109.618C298.522 116.06 301.324 118.674 299.83 123.903C298.336 129.039 281.809 150.234 288.345 169.842C289.652 169.095 290.679 165.827 290.679 165.827L290.678 165.828Z",
  fill: "#995C5A"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M290.772 180.297C290.772 180.297 290.304 170.493 293.013 165.544C295.814 160.596 299.455 157.608 299.455 157.608L296.561 154.62C296.561 154.62 291.799 159.288 291.145 160.688C290.492 162.089 286.57 170.399 287.13 179.643C288.344 180.203 289.465 180.483 290.772 180.296L290.772 180.297Z",
  fill: "#764443"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M292.172 142.762C292.172 142.762 292.826 131.184 287.597 124.555C282.462 118.019 268.923 115.311 266.495 108.121C268.269 109.988 273.031 113.817 277.606 116.151C282.182 118.579 293.853 123.34 294.04 138.747C293.293 142.389 292.173 142.762 292.173 142.762H292.172Z",
  fill: "#764443"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M272.004 113.257C272.004 113.257 266.028 114.097 262.853 111.016L262.667 111.669C262.667 111.669 267.056 115.311 271.911 114.004C272.471 114.004 272.004 113.257 272.004 113.257Z",
  fill: "#67373F"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M298.708 108.494C298.708 108.494 296.001 103.266 298.615 97.5696C298.895 97.7562 298.802 97.1032 298.895 97.7562C298.988 98.4099 297.028 103.545 298.895 106.533C299.175 106.999 298.708 108.493 298.708 108.493V108.494Z",
  fill: "#67373F"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M315.422 115.594C315.422 115.594 320.277 116.155 323.358 113.353C323.638 113.26 323.638 113.633 323.358 114.007C321.117 116.528 316.916 116.901 313.367 116.248C313.087 116.155 315.421 115.594 315.421 115.594H315.422Z",
  fill: "#67373F"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M120.236 190.328V195.687L78.4974 172.365V167.006L83.177 164.289V158.931L151.936 166.029L169.953 155.668L169.913 160.479C154.881 169.483 139.905 178.533 124.916 187.612L120.236 190.329V190.328Z",
  fill: "#F7941E"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M41.7402 231.765L46.3447 229.048V223.689L51.0243 220.972L92.7629 244.37L88.0833 247.086V252.445L83.4038 255.163V260.522L76.0073 264.22L66.874 253.276L71.7045 253.88L41.6652 237.124V231.765H41.7402Z",
  fill: "#F7941E"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M92.6873 238.937V244.295L50.9487 220.898V215.54L55.6282 212.822V207.463L55.1757 207.237L59.8552 204.52V199.161L64.5348 196.444L98.2728 215.313L64.459 196.444V191.085L69.1386 188.368V183.084L106.123 203.765L106.198 203.689L69.4403 183.16L74.1199 180.443V175.084L78.7994 172.367L120.538 195.765L115.859 198.481V203.84L111.179 206.558L111.028 206.482L110.877 206.558V211.841L106.198 214.559V219.917L106.273 219.917L101.594 222.634V227.992L97.3669 230.483V230.861L97.4419 230.937V236.296L92.6873 238.937Z",
  fill: "#F7941E"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M76.007 258.329L34.2684 234.931L38.948 232.214L80.6859 255.612L76.007 258.329Z",
  fill: "#DCBA39"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M76.0823 263.688L34.3438 240.29V234.932L76.0823 258.329V263.688Z",
  fill: "#F7941E"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M80.6857 250.254L38.9478 226.932L43.6274 224.214L85.3652 247.537L80.6857 250.254Z",
  fill: "#DCBA39"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M80.6857 255.613L38.9478 232.291V226.933L80.6857 250.33V255.613Z",
  fill: "#F58220"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2904 242.179L43.5518 218.781L48.2314 216.064L89.97 239.462L85.2904 242.179Z",
  fill: "#DCBA39"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2904 247.538L43.5518 224.14V218.781L85.2904 242.103V247.538Z",
  fill: "#F58220"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M89.8944 239.537L48.1558 216.14V210.781L89.8944 234.179V239.537Z",
  fill: "#F58220"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M89.4416 233.955L47.703 210.558L52.3826 207.84L94.1212 231.238L89.4416 233.955Z",
  fill: "#DCBA39"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M94.0456 225.877L52.307 202.479L56.9866 199.762L98.7252 223.16L94.0456 225.877Z",
  fill: "#DCBA39"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M94.0456 231.235L52.307 207.837V202.479L94.0456 225.876V231.235Z",
  fill: "#F58220"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M98.65 217.804L56.9114 194.406L61.5909 191.689L103.33 215.011L98.65 217.804Z",
  fill: "#DCBA39"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M98.65 223.162L56.9114 199.765V194.406L98.65 217.803V223.162Z",
  fill: "#F58220"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M103.33 215.084L61.591 191.687L61.8898 186.327L103.33 209.725V215.084Z",
  fill: "#F58220"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M103.631 209.725L61.8926 186.327L66.5721 183.61L108.311 206.932L103.631 209.725Z",
  fill: "#DCBA39"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M108.235 201.726L66.4973 178.328L71.1762 175.611L112.915 199.009L108.235 201.726Z",
  fill: "#DCBA39"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M108.235 207.083L66.4973 183.686V178.327L108.235 201.724V207.083Z",
  fill: "#F58220"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M112.839 193.647L71.1006 170.249L75.7802 167.532L117.519 190.93L112.839 193.647Z",
  fill: "#DCBA39"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M112.839 199.006L71.1006 175.608V170.249L112.839 193.647V199.006Z",
  fill: "#F58220"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M117.443 190.933L75.7047 167.536V162.177L117.443 185.575V190.933Z",
  fill: "#F58220"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9618 288.508L41.9487 283.153L76.3782 263.646L75.8542 269.231L41.9618 288.508Z",
  fill: "#F7941E"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M41.7386 283.423L0 260.026L34.6438 240.25L76.3825 263.648L41.7386 283.423Z",
  fill: "#DCBA39"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M41.965 288.553L0.22644 265.156V259.797L41.965 283.194V288.553Z",
  fill: "#F58220"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M76.0359 263.521L34.298 240.199V234.84L76.0359 258.237V263.521Z",
  fill: "#F58220"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M117.217 185.8L75.4789 162.403L110.122 142.628L110.184 142.663L128.303 132.32L170.042 155.718L135.398 175.492L135.336 175.458L117.217 185.8Z",
  fill: "#DCBA39"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M135.203 110.734C135.203 110.309 134.948 109.759 134.632 109.505C134.317 109.251 134.062 109.39 134.062 109.814V117.074C134.062 117.499 134.317 118.049 134.632 118.303C134.948 118.557 135.203 118.419 135.203 117.994V110.734Z",
  fill: "#4D4849"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M135.689 110.829H134.885C134.798 110.829 134.728 110.947 134.728 111.092C134.728 111.238 134.798 111.356 134.885 111.356H135.689C135.776 111.356 135.846 111.238 135.846 111.092C135.846 110.947 135.776 110.829 135.689 110.829Z",
  fill: "#4D4849"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M135.689 116.679H134.885C134.798 116.679 134.728 116.797 134.728 116.943C134.728 117.088 134.798 117.206 134.885 117.206H135.689C135.776 117.206 135.846 117.088 135.846 116.943C135.846 116.797 135.776 116.679 135.689 116.679Z",
  fill: "#4D4849"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M131.511 116.487C130.755 116.105 130.323 115.433 130.092 115.025C130.164 115.011 130.164 115.011 130.237 114.996C130.237 114.996 131.054 114.535 132.527 113.945C133.116 113.74 133.545 113.442 134.103 113.375C135.563 113.2 135.47 113.905 134.728 114.614C133.834 115.469 132.044 116.386 131.511 116.486V116.487Z",
  fill: "#F5E0CD"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M110.676 93.349C110.676 93.349 110.231 90.5293 107.411 90.2327C104.517 89.8617 102.959 92.9037 102.44 97.7268C101.846 102.55 101.92 102.772 101.92 102.772C101.92 102.772 107.04 105.147 110.231 103.365C111.715 102.847 111.789 102.327 111.789 102.327L110.454 95.1294L110.676 93.3482V93.349Z",
  fill: "#430000"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M104.377 164.737C104.451 166.147 106.677 166.741 106.677 166.741C106.677 166.741 106.603 166.444 106.529 165.034C106.603 162.882 107.567 159.246 108.681 155.684C107.864 155.981 106.974 156.277 106.084 156.649C105.639 159.246 105.045 162.511 104.377 164.737Z",
  fill: "#430000"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M114.543 140.249C115.285 137.874 111.352 128.599 111.352 128.599L106.455 133.719L110.091 139.284L108.829 141.658C108.607 141.955 108.458 142.252 108.236 142.549C110.314 141.658 112.836 141.584 114.023 141.658C114.246 141.213 114.394 140.768 114.543 140.249Z",
  fill: "#430000"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M114.023 141.66C112.836 141.66 110.313 141.734 108.236 142.551C106.604 145.667 106.307 151.084 106.307 153.459C106.307 154.275 106.158 155.388 106.01 156.575C106.901 156.204 107.791 155.907 108.607 155.611C110.462 149.971 112.763 144.406 112.763 144.406C112.763 144.406 113.43 143.293 114.024 141.661L114.023 141.66Z",
  fill: "#5E0000"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M119.663 139.879L120.108 137.134L116.398 126.671C116.398 126.671 113.8 126.003 113.652 126.003L110.833 131.049C110.833 131.049 115.359 136.317 116.769 138.988C116.101 140.027 115.656 142.105 115.359 144.182C116.769 142.402 118.327 140.992 119.663 139.879Z",
  fill: "#430000"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M119.663 139.879C118.253 140.992 116.769 142.402 115.359 144.183C115.063 146.483 114.988 148.783 115.063 149.822C115.73 149.897 116.844 149.971 117.957 150.119L119.663 139.879H119.663Z",
  fill: "#5E0000"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M115.136 149.821C115.284 151.676 114.245 161.397 114.245 161.397L116.249 162.287L116.323 160.284L118.03 150.193C116.917 149.971 115.804 149.896 115.137 149.822L115.136 149.821Z",
  fill: "#430000"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M121.216 112.595L119.267 114.1C119.267 114.1 111.419 108.878 108.747 106.133C109.712 104.426 110.974 103.09 110.974 103.09C110.974 103.09 112.235 103.684 113.126 105.761C115.447 109.689 120.646 111.556 121.216 112.594L121.216 112.595Z",
  fill: "#B43123"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M111.723 107.601C111.871 107.23 111.945 107.007 112.02 106.784C112.391 105.3 111.5 102.258 108.903 101.665C106.307 101.071 101.261 104.261 101.261 104.261L101.335 105.523L102.226 108.342C102.226 108.342 103.264 109.678 104.229 111.162C104.897 110.346 107.197 108.119 111.723 107.601Z",
  fill: "#F7941E"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M111.723 107.603C107.197 108.123 104.897 110.348 104.155 111.165C104.822 112.203 105.416 113.317 105.564 114.059C105.638 114.43 105.564 114.949 105.49 115.617C106.38 115.765 107.864 115.617 109.793 114.059C109.719 112.055 111.129 109.236 111.722 107.603H111.723Z",
  fill: "#9C6026"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M108.904 108.199C108.829 108.199 108.681 108.273 108.607 108.273C108.607 108.421 108.681 108.57 108.681 108.718C108.756 108.644 108.83 108.496 108.904 108.199V108.199Z",
  fill: "#F5E0CD"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M110.165 115.393C109.943 115.022 109.794 114.576 109.794 114.057C107.865 115.615 106.38 115.763 105.491 115.615C105.045 118.286 103.413 123.035 103.116 126.448C102.894 129.119 105.12 132.607 106.826 134.982C107.272 134.907 107.643 134.907 108.088 134.833C110.685 134.759 112.911 134.017 114.469 133.275C116.473 132.459 117.586 131.494 118.18 130.826C115.88 124.519 111.279 117.174 110.166 115.393H110.165Z",
  fill: "#830B0D"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M106.677 115.616C106.38 115.69 106.083 115.69 105.786 115.69C106.083 115.69 106.379 115.69 106.677 115.616Z",
  fill: "#700008"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M106.603 116.655C106.603 116.655 106.678 116.58 106.678 115.616C106.381 115.691 106.085 115.691 105.787 115.691C105.787 115.691 105.787 115.691 105.713 115.691C105.639 115.691 105.564 115.691 105.491 115.691C105.045 118.362 103.413 123.11 103.116 126.524C102.894 129.195 105.12 132.683 106.826 135.057C107.272 134.982 107.643 134.982 108.088 134.909C108.608 134.909 109.127 134.834 109.646 134.76C109.275 134.018 108.014 131.644 106.233 128.601C104.08 124.743 106.603 116.655 106.603 116.655Z",
  fill: "#700008"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M105.491 109.978C104.303 108.123 102.745 106.639 102.745 106.639L102.3 108.494C102.522 108.865 103.413 109.978 104.155 111.165C104.451 110.868 104.897 110.423 105.491 109.978Z",
  fill: "#CD8221"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M105.491 109.978C104.823 110.498 104.452 110.869 104.155 111.165C104.822 112.204 105.416 113.317 105.564 114.059C105.638 114.43 105.564 114.949 105.49 115.617C105.786 115.691 106.232 115.691 106.677 115.617C106.677 115.172 106.751 114.43 106.751 113.391C106.751 112.278 106.232 111.091 105.49 109.978L105.491 109.978Z",
  fill: "#963C28"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M100.89 115.396C101.186 113.467 101.409 115.1 102.967 110.128C104.526 105.156 102.151 104.192 101.335 104.192C100.519 104.192 100.444 105.305 100.444 105.305C100.444 105.305 99.9247 110.202 99.8511 111.612C99.7767 113.021 99.4801 114.877 98.1443 117.399C97.922 117.844 97.699 118.586 97.4767 119.328C98.3673 118.29 99.5545 117.176 100.815 116.286C100.815 116.138 100.815 115.767 100.89 115.396V115.396Z",
  fill: "#A32C1D"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M97.4024 119.474C96.5862 123.035 96.2895 128.971 96.3639 129.342C96.4382 129.713 97.4024 129.788 97.4024 129.788C97.4024 129.788 99.8511 121.552 100.593 120.067C101.187 118.88 100.815 117.841 100.815 116.431C99.4795 117.322 98.3666 118.435 97.4024 119.473V119.474Z",
  fill: "#8B1518"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M102.596 143.663C103.041 143.738 103.487 143.367 103.487 142.921L104.525 133.795C104.6 133.35 104.229 132.904 103.858 132.831L90.0565 131.272C89.8342 131.272 89.6855 131.347 89.4633 131.421L88.4983 132.385L89.018 132.831L88.0538 141.141C87.9794 141.586 88.3504 142.032 88.7213 142.105L101.039 143.515L101.558 143.961L102.597 143.664L102.596 143.663Z",
  fill: "#A93712"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M102.3 143.442L103.339 134.612C103.413 134.167 103.116 133.721 102.671 133.721L89.3895 132.238C88.9442 132.163 88.5732 132.534 88.4989 132.979L87.4604 141.81C87.386 142.255 87.6827 142.7 88.128 142.7L101.41 144.184C101.855 144.184 102.226 143.887 102.301 143.442H102.3Z",
  fill: "#C8541A"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M96.1409 130.606C95.1023 130.458 94.2117 131.2 94.1374 132.239C93.9887 133.277 94.7306 134.168 95.7699 134.242L97.8477 134.465C98.8862 134.613 99.7768 133.871 99.8511 132.832C99.9991 131.793 99.2579 130.903 98.2186 130.829L96.1409 130.606ZM93.3212 132.09C93.4691 130.681 94.805 129.641 96.2145 129.79L98.2923 130.012C99.7025 130.161 100.741 131.496 100.592 132.906C100.444 134.317 99.1085 135.355 97.6983 135.206L95.6205 134.984C94.211 134.835 93.1718 133.575 93.3204 132.09H93.3212Z",
  fill: "#C8541A"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M114.277 163.567C114.277 163.567 113.666 163.567 113.666 163.634C113.666 163.77 113.598 164.11 113.598 164.11C113.598 164.11 114.346 164.518 114.753 165.061C115.16 165.605 117.063 167.508 118.626 167.644H119.17L119.306 167.032L118.762 166.556L116.927 164.993L114.276 163.566L114.277 163.567Z",
  fill: "#430000"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M114.277 160.918C114.277 160.918 114.141 161.802 114.073 162.141C114.005 162.481 113.598 163.296 113.598 163.568C113.598 163.84 114.549 164.247 114.889 164.519C115.229 164.791 116.995 166.422 117.947 166.694C118.898 166.966 119.035 166.966 119.035 166.966C119.035 166.966 119.442 166.015 119.102 165.471C118.695 164.927 116.656 163.229 116.52 162.889C116.384 162.549 115.705 160.646 115.705 160.646L114.278 160.918H114.277Z",
  fill: "#5E0000"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M105.381 168.241L103.614 168.105C103.614 168.105 103.478 168.105 103.478 168.377C103.478 168.649 103.478 169.125 103.478 169.125C103.478 169.125 104.905 170.008 105.245 170.416C105.585 170.824 107.283 172.591 108.71 172.455L109.254 172.319C109.254 172.319 109.39 171.504 109.051 171.164C108.711 170.825 108.575 170.825 108.575 170.825L105.381 168.242V168.241Z",
  fill: "#430000"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M106.332 164.637C106.332 164.637 106.469 166.472 107.08 167.151C107.76 167.83 109.255 169.733 108.983 171.501C108.643 171.704 107.08 170.957 106.4 170.278C105.652 169.598 104.565 168.783 104.293 168.647C104.021 168.511 103.682 168.103 103.682 168.103C103.682 168.103 104.021 166.065 104.293 165.452C104.565 164.909 104.361 164.025 104.361 164.025L106.332 164.638L106.332 164.637Z",
  fill: "#5E0000"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M131.615 116.474C131.529 116.488 131.357 116.516 131.271 116.531C127.881 116.938 119.884 114.559 119.234 114.062C121.346 109.987 124.847 115.314 129.852 115.026C130.211 115.42 130.723 116.092 131.615 116.474H131.615Z",
  fill: "#8B1518"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M106.533 97.6079C107.239 97.7434 108.223 98.8833 109.334 97.2245C110.299 95.8158 109.217 92.0807 108.524 91.6493C107.831 91.2178 105.056 90.7572 104.839 93.0697C104.797 93.5135 104.676 94.3713 104.636 94.7299L104.284 94.5623C104.365 95.0768 104.679 96.057 105.096 96.6349C105.512 97.2129 105.98 97.2887 106.533 97.6072V97.6079Z",
  fill: "#F5E0CD"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M109.33 101.9L108.588 101.753C108.588 101.753 108.044 98.9787 108.214 97.8549C107.582 97.93 107.023 97.441 106.575 97.355C106.022 97.0372 105.483 96.557 105.054 95.9615C104.93 95.7895 104.821 95.6161 104.728 95.4434C105.555 97.1159 105.902 97.9905 105.768 99.5253C105.62 101.158 105.248 102.345 105.248 102.345C105.248 102.345 108.29 105.09 108.736 108.355C108.81 108.355 108.884 108.281 109.033 108.281C109.553 106.649 109.33 101.9 109.33 101.9V101.9Z",
  fill: "#F5E0CD"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M104.808 94.3714C104.808 94.3714 103.807 94.2439 104.005 95.0667C104.203 95.8895 104.547 96.208 105.045 96.189C105.062 95.7896 104.808 94.3714 104.808 94.3714Z",
  fill: "#EBC19C"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M109.105 101.853L108.588 101.75C108.588 101.75 108.068 99.0982 108.203 97.9292C107.998 97.9715 107.804 97.9897 107.632 97.9729C106.44 97.8694 106.294 97.9482 106.759 98.451C107.075 98.959 108.556 102.839 108.924 102.751C109.073 102.745 109.138 102.52 109.278 102.292L109.204 102.295C109.204 102.295 109.164 102.124 109.105 101.852V101.853Z",
  fill: "#EBC19C"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M106.905 93.2532C108.226 92.8234 109.189 92.0148 109.058 91.4471C108.926 90.8794 107.748 90.7676 106.428 91.1974C105.107 91.6272 104.143 92.4358 104.275 93.0035C104.407 93.5712 105.584 93.683 106.905 93.2532Z",
  fill: "#430000"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M107.895 94.3394C107.895 94.3394 108.712 95.4917 108.687 95.7001C108.663 95.9085 107.795 95.6484 107.795 95.6484C107.795 95.6484 107.791 94.3271 107.895 94.3394Z",
  fill: "#CE9D77"
});

var _ref157 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_259_1144",
  x1: 177.413,
  y1: 32.7567,
  x2: 177.413,
  y2: 45.5878,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA98C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0392157,
  stopColor: "#FFA98C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.188235,
  stopColor: "#FFA98C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEECA8"
})));

const SvgErrorPageLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 327,
  height: 289,
  viewBox: "0 0 327 289",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgErrorPageLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error-page-logo.58b8370f.svg";
export { ForwardRef as ReactComponent };